import React from 'react'
import Teaser from '@/components/Teaser/Teaser'
import { Typography } from '@/components/Typography'
import { WidgetTeaserProps } from '@/types/cms'
import styles from './TopicBox.module.scss'
import AppContext from '@/types/context'

export default function TopicBox({ item, context }: Readonly<{ item: WidgetTeaserProps; context: AppContext }>) {
  return (
    <div className={styles.topicbox}>
      {item.model?.fields?.headline && (
        <Typography variant="m" weight="bold" color="darkgrey">
          {item.model.fields.headline}
        </Typography>
      )}

      {item.items?.map((teaser) => (
        <div className={styles.wrapper} key={teaser.id}>
          <React.Fragment key={item.id}>
            <Teaser teaserImgLeft isInline as="article" item={item} context={context} teaser={teaser} />
          </React.Fragment>
        </div>
      ))}
    </div>
  )
}
